// extracted by mini-css-extract-plugin
export default {"container":"styles_container__iyCPI","description":"styles_description__+MUan"};